import POPUP_MESSAGE_TYPE from "./popupMessageType";
export default {
    [POPUP_MESSAGE_TYPE.ERROR]: "icon-alert-triangle notify-error-icon",
    [POPUP_MESSAGE_TYPE.INFO]: "icon-info-circle notify-info-icon",
    [POPUP_MESSAGE_TYPE.SUCCESS]: "icon-circle-check notify-success-icon"
};
